module.exports = __webpack_public_path__ + "static/img/1c.298a1a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/1c.jpg
// module id = 4qSA
// module chunks = 0